import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-parciales-modal',
  templateUrl: './parciales-modal.component.html',
  styleUrls: ['./parciales-modal.component.scss']
})
export class ParcialesModalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
